var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 15.3329C18.3899 15.3329 18.017 15.4112 17.6708 15.5358C17.8604 15.113 17.9876 14.6427 17.9876 14.1404C17.9876 12.1528 16.0001 10.6621 16.0001 10.6621C16.0001 10.6621 14.0125 12.1528 14.0125 14.1404C14.0125 14.6426 14.1397 15.113 14.3294 15.5358C13.9831 15.4113 13.6102 15.3329 13.2175 15.3329C11.2299 15.3329 9.73926 17.3204 9.73926 17.3204C9.73926 17.3204 11.2299 19.308 13.2175 19.308C14.3828 19.308 15.3767 18.625 16.0001 18.0597C16.6236 18.625 17.6174 19.308 18.7828 19.308C20.7703 19.308 22.261 17.3204 22.261 17.3204C22.261 17.3204 20.7702 15.3329 18.7826 15.3329Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 6.26099L16.4114 7.52449H17.74L16.6653 8.30549L17.0755 9.56899L16.0008 8.78799L14.9262 9.56899L15.3364 8.30549L14.2617 7.52449H15.5903L16.0008 6.26099Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9483 8.47095L11.7382 9.18207L12.6587 8.6507L12.2264 9.62163L13.0162 10.3329L11.9592 10.2218L11.527 11.1927L11.3058 10.1531L10.2489 10.042L11.1693 9.51051L10.9483 8.47095Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 12.1692L8.28963 12.3902L8.82106 11.4697L8.93219 12.5267L9.97169 12.7478L9.00081 13.1801L9.11194 14.237L8.40063 13.4473L7.42975 13.8795L7.96119 12.959L7.25 12.1692Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0522 8.47095L20.2624 9.18207L19.3419 8.6507L19.7741 9.62163L18.9844 10.3329L20.0414 10.2218L20.4736 11.1927L20.6948 10.1531L21.7517 10.042L20.8313 9.51051L21.0522 8.47095Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7508 12.1692L23.7112 12.3902L23.1798 11.4697L23.0686 12.5267L22.0291 12.7478L23 13.1801L22.8889 14.237L23.6002 13.4473L24.5711 13.8795L24.0396 12.959L24.7508 12.1692Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24.8733C17.5788 24.8733 19.034 24.3465 20.2014 23.4602H11.7986C12.966 24.3465 14.4211 24.8733 16 24.8733Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62292 20.6992C9.84374 21.2046 10.1237 21.6779 10.4526 22.1123H21.5475C21.8764 21.678 22.1564 21.2046 22.3772 20.6992H9.62292Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMacao);
export default __webpack_public_path__ + "static/media/flag_macao.228b275be629a6b4b081b7fbd340824b.svg";
export { ForwardRef as ReactComponent };